import React, { useState, useEffect } from 'react';
import './Landing.css';

const Landing = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const desktopSlides = [
    {
      url: '/images/landing/1.jpeg',
      caption: 'Welcome to EMPACK',
    },
    {
      url: '/images/landing/2.jpeg',
      caption: 'Discover Amazing Products',
    },
    {
      url: '/images/landing/3.jpeg',
      caption: 'Contact Our Team',
    },
  ];

  const mobileSlides = [
    {
      url: '/images/landing/m1.jpeg',
      caption: '',
    },
    {
      url: '/images/landing/m2.jpeg',
      caption: '',
    },
    {
      url: '/images/landing/m3.jpeg',
      caption: '',
    },
  ];

  const slides = isMobile ? mobileSlides : desktopSlides;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === slides.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="carousel-container">
      <div className="carousel-slides">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${
              index === currentSlide ? 'active' : ''
            }`}
            style={{ backgroundImage: `url(${slide.url})` }}
          >
            <div className="carousel-caption">
              <h1 className={index === currentSlide ? 'handwriting' : ''}>
                {slide.caption}
              </h1>
            </div>
          </div>
        ))}
      </div>

      <div className="carousel-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Landing;
